<app-breadcrumb [title]="page_name" [breadcrumb]="page_name" [currentUrl]="currentUrl"></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
    <div class="container">
        <div class="row">
            <div class="col-sm-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        {{'my account' | translate}}
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back' | translate}}
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <ul>
                                <li><a data-lng="es" [routerLink]="'/pages/dashboard'">
                                        {{'address' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-orders'">
                                        {{'orders' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-coupones'">
                                        {{'coupones' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/browse-log'">
                                        {{'browse log' | translate}}
                                    </a>
                                </li>

                                <li class="active"><a data-lng="es" [routerLink]="'/pages/profile'">
                                        {{'my profile' | translate}}
                                    </a>
                                </li>
                                <li>
                                    <a data-lng="es" href="javascript:void(0)" (click)="userLogOut()">

                                        {{'logout' | translate}}
                                    </a>
                                </li>

                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mt-3 col-sm-9">
                <h3>{{'PERSONAL DETAIL' | translate }}</h3>
                <form class="theme-form">
                    <div class="form-row">
                        <div class="form-group">

                        </div>
                        <div class="col-md-12">
                            <div class="errorOccurred" *ngIf="errorOccurred">
                                {{errorOccurredMessage}}
                                <br>
                                <br>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <label for="user_name">{{'first name' | translate}}</label>
                            <input type="text" class="form-control" id="user_name"
                                placeholder="{{'Full Name' | translate}}" name="user_name" [(ngModel)]="user_name"
                                required="">
                            <span class="errorOccurred" *ngIf="successUser_name">{{errorUserNameMessage}} </span>
                        </div>
                        <!-- <div class="col-md-6">
                            <label for="last_name">{{'last name' | translate}}</label>
                            <input type="text" class="form-control" id="last_name"
                                placeholder="{{'last name' | translate}}" name="last_name" [(ngModel)]="last_name"
                                required="">
                            <span class="errorOccurred" *ngIf="successLast_name">{{errorLastNameMessage}} </span>
                        </div> -->
                        <div class="col-md-6">
                            <label for="mobile">{{'mobile' | translate}}</label>
                            <input type="text" class="form-control" id="mobile" placeholder="{{'mobile' | translate}}"
                                name="mobile" [(ngModel)]="mobile" required="">
                            <span class="errorOccurred" *ngIf="successMobile">{{errorMobileMessage}} </span>
                        </div>

                        <div class="col-md-6">
                            <label for="email">{{'Email' | translate}}</label>
                            <input type="text" class="form-control" id="email" name="email" [(ngModel)]="email"
                                placeholder="{{'Email' | translate}}" required="">
                            <span class="errorOccurred" *ngIf="successEmail">{{errorSuccessEmailMessage}} </span>
                        </div>
                        <div class="col-md-6">
                            <label for="password">{{'Password' | translate}}</label>
                            <input type="text" class="form-control" id="password" name="password" [(ngModel)]="password"
                                placeholder="{{'Password' | translate}}" required="">
                            <span class="errorOccurred" *ngIf="successPassword">{{errorPasswordMessage}} </span>
                        </div>
                        <div class="col-md-6">
                            <label for="confirmPassword">{{'confirm password' | translate}}</label>
                            <input type="text" class="form-control" id="confirmPassword" name="confirmPassword"
                                [(ngModel)]="confirmPassword" placeholder="{{'confirm password' | translate}}"
                                required="">
                            <span class="errorOccurred" *ngIf="successconfirmPassword">{{errorconfirmPasswordMessage}}
                            </span>
                        </div>
                        <div class="col-md-12">
                            <label for="address">{{'Address' | translate}}</label>
                            <input type="text" class="form-control" id="address" name="address" [(ngModel)]="address"
                                placeholder="{{'Address' | translate}}" required="">
                        </div>
                        <!-- <div class="col-md-12 border-test1">
                            <label for="exampleFormControlTextarea1">{{'Write Your Brief' | translate}}</label>
                            <textarea class="mb-0 form-control" placeholder="{{'Write Your Brief' | translate}}" id="exampleFormControlTextarea1" name="brief"  [(ngModel)]="brief" rows="6"></textarea>
                        </div> -->


                        <div class="col-md-12">
                            <br>
                            <br>
                            <button class="btn btn-sm btn-solid" type="submit" (click)="userEditProfile()">{{'Save
                                setting' | translate}}</button>
                            <br>
                            <br>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>

<!-- address section start -->
<!-- <section class="contact-page register-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h3>SHIPPING ADDRESS</h3>
                <form class="theme-form">
                    <div class="form-row">
                        <div class="col-md-6">
                            <label for="name">flat / plot</label>
                            <input type="text" class="form-control" id="home-ploat" placeholder="company name" required="">
                        </div>
                        <div class="col-md-6">
                            <label for="name">Address *</label>
                            <input type="text" class="form-control" id="address-two" placeholder="Address" required="">
                        </div>
                        <div class="col-md-6">
                            <label for="email">Zip Code *</label>
                            <input type="text" class="form-control" id="zip-code" placeholder="zip-code" required="">
                        </div>
                        <div class="col-md-6 select_input">
                            <label for="review">Country *</label>
                            <select class="form-control" size="1">
                                <option value="India">India</option>
                                <option value="UAE">UAE</option>
                                <option value="U.K">U.K</option>
                                <option value="US">US</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="review">City *</label>
                            <input type="text" class="form-control" id="city" placeholder="City" required="">
                        </div>
                        <div class="col-md-6">
                            <label for="review">Region/State *</label>
                            <input type="text" class="form-control" id="region-state" placeholder="Region/state" required="">
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-sm btn-solid" type="submit" (click)="userEditProfile()">Save setting</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section> -->
<!-- Section ends -->


